import { Directive } from 'lit/directive.js';
import { noChange } from 'lit';
export class InlineScriptDirective extends Directive {
    constructor(partInfo) {
        super(partInfo);
        this.scriptList = [];
    }
    nodeScriptReplace(node) {
        if (this.nodeScriptIs(node) === true) {
            let tmpParentNode = node.parentNode;
            this.nodeScriptClone(node);
            tmpParentNode === null || tmpParentNode === void 0 ? void 0 : tmpParentNode.removeChild(node);
        }
        else {
            let i = 0;
            let children = node === null || node === void 0 ? void 0 : node.childNodes;
            while (i < (children === null || children === void 0 ? void 0 : children.length)) {
                this.nodeScriptReplace(children[i++]);
            }
        }
        return node;
    }
    nodeScriptIs(node) {
        return (node === null || node === void 0 ? void 0 : node.tagName) === 'SCRIPT';
    }
    nodeScriptClone(node) {
        var _a, _b, _c, _d;
        let script = document.createElement("script");
        script.textContent = this.scriptURIDecode(node.innerHTML);
        for (let i = node.attributes.length - 1; i >= 0; i--) {
            script.setAttribute((_b = (_a = node.attributes[i]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '', (_d = (_c = node.attributes[i]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '');
        }
        this.scriptList.push(script);
        return script;
    }
    scriptURIDecode(iScript) {
        let txt = document.createElement('textarea');
        txt.innerHTML = iScript;
        return txt.value;
    }
    update(part, values) {
        let curEle = values[0];
        let curParentNode = part.parentNode;
        /* expects the value input to be the <html> structure from xgetpost witch has 2 relevant nodes head && body*/
        if (curEle.children.length > 1) {
            let oldHead = curParentNode.querySelector('head');
            let oldBody = curParentNode.querySelector('body');
            let headEle = curEle.children[0];
            let bodyEle = curEle.children[1];
            this.scriptList = [];
            this.nodeScriptReplace(bodyEle);
            oldHead ? curParentNode.replaceChild(headEle, oldHead) : curParentNode.appendChild(headEle);
            oldBody ? curParentNode.replaceChild(bodyEle, oldBody) : curParentNode.appendChild(bodyEle);
            Array.from(curParentNode.querySelectorAll('script')).filter(x => x.parentNode == curParentNode).forEach(y => { y.remove(); });
            /* scripts deleted and then added to parent node, only thing that worked */
            this.scriptList.forEach(script => curParentNode.prepend(script));
        }
        return noChange;
    }
    render(value) {
        return noChange;
    }
}
//# sourceMappingURL=InlineScript.js.map